// extracted by mini-css-extract-plugin
module.exports = {"root":"Dialog_root__u0Q9I"};